const risks = {
	image: 'risks.jpg',
	path: '/risks',
	name: 'Risk Management',
	title: 'Risk Management',
	description: 'As a financial platform that works officially and has a permit...',
	content: (theme) => (
		<div className='container py-5'>
			<div className='row'>
				<div className='col-12'>
					<h3 className='fw-bold mt-5'>Core Risk Management Strategies</h3>
					<ol>
						<li>
							<b> Smart Contract Automation</b>: MMP WORLD utilizes open-source smart
							contracts to automate platform operations. This approach enhances
							transaction speed, minimizes human error, and ensures transparency and
							security in financial activities
						</li>
						<li>
							<b> Grid Trading Technology</b>: The platform implements advanced grid
							trading strategies to manage market volatility. This technique involves
							placing buy and sell orders at predetermined intervals, allowing for
							systematic capital deployment and risk mitigation.
						</li>
						<li>
							<b> Investment Diversification</b>: By diversifying investments across
							various projects and assets, MMP WORLD reduces exposure to any single
							point of failure, thereby enhancing portfolio resilience against market
							fluctuations.
						</li>
						<li>
							<b> Continuous Monitoring and Due Diligence</b>: The platform conducts
							ongoing assessments of investment portfolios and market conditions. This
							proactive approach enables timely identification and management of
							potential risks.
						</li>
					</ol>
					<h3 className='fw-bold mt-5'>Development and Financial Strategies</h3>
					<p>
						<b> Market Making for BCN Token</b>: MMP WORLD actively engages in
						market-making activities for the BEMCHAIN (BCN) token. This involves
						providing liquidity, stabilizing prices, and fostering a robust trading
						environment.
					</p>
					<p>
						<b> Controlled Fund Utilization</b>: Funds raised are strategically
						allocated to support market-making efforts, including purchasing BCN tokens,
						enhancing liquidity pools, and executing trades to maintain price stability.
					</p>
					<p>
						<b> Transparent Profit Distribution</b>: The platform ensures that profits
						generated are used to pay investor interests and rewards, with a portion
						reinvested into project development. This transparent approach fosters trust
						and aligns with investor interest.
					</p>
					<h3 className='fw-bold mt-5'>Security Measures</h3>
					<ul>
						<li>
							<i> Two-Factor Authentication (2FA):</i> To safeguard user accounts, MMP
							WORLD employs 2FA, adding an extra layer of security against
							unauthorized access.
						</li>
						<li>
							<i> *Cold and Hot Wallets:</i> The platform uses a combination of cold
							(offline) and hot (online) wallets to store assets securely, balancing
							accessibility with protection against cyber threats.
						</li>
						<li>
							<i> Manual Withdrawal Verification:</i> Withdrawals undergo manual
							verification processes to prevent fraudulent activities and ensure the
							legitimacy of transactions.
						</li>
					</ul>
					<h3 className='fw-bold mt-5'>Future Goals</h3>
					<p>
						MMP WORLD is focused on achieving major milestones, including listing the
						BCN token on leading exchanges, expanding its market capitalization, and
						growing its user base. These goals are pursued through strategic marketing,
						continuous platform enhancements, and a strong commitment to effective risk
						management.
					</p>
					<p>
						In summary, MMP WORLD’s integrated risk management approach — blending
						technological innovation, strategic financial practices, and rigorous
						security measures — positions it as a trusted platform for investors seeking
						stable and secure cryptocurrency opportunities.
					</p>
				</div>
			</div>
		</div>
	),
};

export default risks;
